import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import { getToken } from './auth'
import apiEnv from '@/api/env'

// 通用文件流导出（Blob 下载），鉴权头与 request.js 保持一致使用 useraxj
export function exportFile ({ url, data, method = 'post', defaultFileName = '导出文件.xlsx' }) {
  const token = getToken()
  // 表单参数：普通对象自动序列化，与 request.js 统一表单提交约定
  const body = (method === 'post' && data && typeof data === 'object' && !(data instanceof FormData))
    ? qs.stringify(data)
    : data
  const params = method === 'get' ? { params: data } : { data: body }

  return axios({
    url: apiEnv.baseURL + url,
    method,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      useraxj: token || ''
    },
    ...params
  }).then(async response => {
    // 后端导出接口在未登录/无权限时仍返回 HTTP 200 + JSON 业务错误，
    // 此时不能把 JSON 当文件保存，需读出错误信息提示用户
    const contentType = response.headers['content-type'] || ''
    if (contentType.indexOf('application/json') > -1) {
      let msg = '导出失败，请稍后重试'
      try {
        const res = JSON.parse(await blobToText(response.data))
        msg = (res && res.msg) || msg
      } catch (e) { /* JSON 解析失败时使用默认提示 */ }
      Message.error(msg)
      return Promise.reject(new Error(msg))
    }

    // 从 Content-Disposition 解析文件名
    const disposition = response.headers['content-disposition']
    let fileName = defaultFileName
    if (disposition) {
      const match = disposition.match(/filename\*?=(?:UTF-8'')?([^;\n]+)/i)
      if (match) {
        fileName = decodeURIComponent(match[1].replace(/['"]/g, ''))
      }
    }

    const blob = new Blob([response.data])
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = fileName
    link.click()
    URL.revokeObjectURL(link.href)
  }).catch(error => {
    // 网络层异常（非 2xx / 超时等）统一提示；
    // 上方 JSON 业务错误 reject 的 Error 无 response 字段，不会重复弹窗
    if (error.response) {
      Message.error('导出失败，请稍后重试')
    }
    return Promise.reject(error)
  })
}

// Blob 转文本（FileReader 兼容性最好）
function blobToText (blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsText(blob, 'utf-8')
  })
}
